/**
 *  @class
 *  @function SlideShow
 */
if (!customElements.get('slide-show')) {
  class SlideShow extends HTMLElement {
    constructor() {
      super();
      const slideshow = this,
        dataset = slideshow.dataset;

      let dots = dataset.dots === 'true',
        slideshow_slides = Array.from(slideshow.querySelectorAll('.carousel__slide')),
        autoplay = dataset.autoplay == 'false' ? false : parseInt(dataset.autoplay, 10),
        align = dataset.align == 'center' ? 'center' : 'left',
        fade = dataset.fade == 'true' ? true : false,
        prev_button = slideshow.querySelector('.flickity-prev'),
        next_button = slideshow.querySelector('.flickity-next'),
        custom_dots = slideshow.querySelector('.flickity-page-dots'),
        progress_bar = slideshow.parentNode.querySelector('.flickity-progress--bar'),
        animations = [],
        rightToLeft = document.dir === 'rtl',
        animations_enabled = document.body.classList.contains('animations-true') && typeof gsap !== 'undefined';

      if (slideshow_slides.length < 1) {
        return;
      }
      this._animations = animations;
      const args = {
        wrapAround: true,
        cellAlign: align,
        pageDots: false,
        contain: true,
        fade: fade,
        autoPlay: autoplay,
        rightToLeft: rightToLeft,
        prevNextButtons: false,
        cellSelector: '.carousel__slide',
        on: {}
      };


      if (slideshow.classList.contains('image-with-text-slideshow__image')) {
        let main_slideshow = slideshow.parentNode.querySelector('.image-with-text-slideshow__content'),
          image_slideshow_slides = slideshow.querySelectorAll('.image-with-text-slideshow__image-media');
        args.draggable = false;
        args.asNavFor = main_slideshow;

        if (image_slideshow_slides.length) {
          if (image_slideshow_slides[0].classList.contains('desktop-height-auto')) {
            args.adaptiveHeight = true;
          }
        }
      }
      if (slideshow.classList.contains('customer-reviews__image')) {
        let main_slideshow = slideshow.parentNode.querySelector('.customer-reviews__content');
        args.draggable = false;
        args.asNavFor = main_slideshow;
      }
      if (slideshow.classList.contains('image-with-text-slideshow__content') ||
        slideshow.classList.contains('testimonials__carousel') ||
        slideshow.classList.contains('customer-reviews__content') ||
        slideshow.classList.contains('customer-reviews__image')) {
        args.adaptiveHeight = true;
      }
      if (slideshow.classList.contains('custom-dots')) {

        if (animations_enabled && slideshow.classList.contains('main-slideshow')) {
          this.prepareAnimations(slideshow, animations);
          // Reveal text containers for non-video slides only.
          // Video slides keep CSS opacity:0 and are revealed by their own simple timeline.
          slideshow.querySelectorAll('.slideshow__slide').forEach(function (slide) {
            if (!slide.querySelector('.slideshow__slide-video-bg')) {
              gsap.set(slide.querySelectorAll('.split-text,.button'), { autoAlpha: 1 });
            }
          });
        }
        args.pauseAutoPlayOnHover = false;

        args.on = {
          staticClick: function () {
            this.unpausePlayer();
          },
          ready: function () {
            let flkty = this;
            // Animations.
            if (animations_enabled && slideshow.classList.contains('main-slideshow')) {
              slideshow.animateSlides(0, animations);
            }

            // Custom Dots.
            if (dots && custom_dots) {
              let dots = custom_dots.querySelectorAll('li');
              dots.forEach((dot, i) => {
                dot.addEventListener('click', (e) => {
                  flkty.select(i);
                });
              });
              dots[this.selectedIndex].classList.add('is-selected');
            }
            document.fonts.ready.then(function () {
              flkty.resize();
            });

            // Video Support.
            let video_container = slideshow.activeVideoContainer(flkty.cells[0].element);
            if (video_container) {
              slideshow.videoPauseAll(flkty.cells[0].element, video_container);
              if (video_container.querySelector('iframe')) {
                video_container.querySelector('iframe').onload = function () {
                  slideshow.videoPlay(video_container);
                };
              } else if (video_container.querySelector('video')) {
                video_container.querySelector('video').onloadstart = function () {
                  slideshow.videoPlay(video_container);
                };
              }
            }
          },
          change: function (index) {
            flkty.cells[0].element.classList.remove('is-initial-selected');
            let previousIndex = fizzyUIUtils.modulo(this.selectedIndex - 1, this.slides.length),
              nextIndex = fizzyUIUtils.modulo(this.selectedIndex + 1, this.slides.length);

            // Animations.
            if (animations_enabled && slideshow.classList.contains('main-slideshow')) {
              setTimeout(() => {
                slideshow.animateReverse(previousIndex, animations);
              }, 300);
              slideshow.animateSlides(index, animations);
            }

            // Custom Dots.
            if (dots && custom_dots) {
              let dots = custom_dots.querySelectorAll('li');
              dots.forEach((dot, i) => {
                dot.classList.remove('is-selected');
              });
              dots[this.selectedIndex].classList.add('is-selected');
            }

            // AutoPlay
            if (autoplay) {
              this.stopPlayer();
              this.playPlayer();
            }

            // Video Support.
            // previous slide
            slideshow.videoPauseAll(flkty.cells[previousIndex].element);
            // next slide
            slideshow.videoPauseAll(flkty.cells[nextIndex].element);
            // current slide
            let video_container = slideshow.activeVideoContainer(flkty.cells[index].element);
            if (video_container) {
              // Keep the off-viewport video (if any) paused.
              slideshow.videoPauseAll(flkty.cells[index].element, video_container);
              if (video_container.querySelector('iframe')) {
                if (video_container.querySelector('iframe').classList.contains('lazyload')) {
                  video_container.querySelector('iframe').addEventListener('lazybeforeunveil', slideshow.videoPlay(video_container));
                  lazySizes.loader.checkElems();
                } else {
                  slideshow.videoPlay(video_container);
                }
              } else if (video_container.querySelector('video')) {
                slideshow.videoPlay(video_container);
              }
            }

          }
        };
      }
      if (slideshow.classList.contains('shoppable-video-reels--carousel')) {
        args.on.staticClick = function (event, pointer, cellElement, cellIndex) {
          if (typeof cellIndex == 'number') {
            flkty.select(cellIndex);
          }
        };
      }
      if (slideshow.classList.contains('main-slideshow')) {
        if (slideshow.classList.contains('desktop-height-image') || slideshow.classList.contains('mobile-height-image')) {
          args.adaptiveHeight = true;
        }
      }
      if (slideshow.classList.contains('products') || slideshow.classList.contains('collection-grid__carousel')) {
        let loop = slideshow.dataset.loop === 'true';

        function getResponsiveCpv() {
          var w = slideshow.offsetWidth;
          var cpvMobile = parseFloat(slideshow.dataset.cellsPerViewMobile);
          var cpvTablet = parseFloat(slideshow.dataset.cellsPerViewTablet);
          var cpvDesktop = parseFloat(slideshow.dataset.cellsPerView) || 4;
          if (w <= 767) return cpvMobile || cpvDesktop;
          if (w <= 1067) return cpvTablet || cpvDesktop;
          return cpvDesktop;
        }

        let cpv = getResponsiveCpv();
        args.wrapAround = loop;
        args.contain = slideshow.dataset.contain === 'true';
        args.percentPosition = false;
        
        var mobileCellAlign = slideshow.dataset.cellAlignMobile || null;
        var baseCellAlign = 'left';
        args.cellAlign = (mobileCellAlign && window.innerWidth <= 767) ? mobileCellAlign : baseCellAlign;

        function applyPxWidths(flkty) {
          cpv = getResponsiveCpv();
          var vpWidth = slideshow.offsetWidth;
          if (vpWidth <= 0) return;
          var cellPx = Math.floor(vpWidth / cpv);
          var cells = flkty ? flkty.cells : slideshow_slides;
          cells.forEach(function (item) {
            var el = flkty ? item.element : item;
            el.style.setProperty('width', cellPx + 'px', 'important');
            el.style.setProperty('max-width', cellPx + 'px', 'important');
            el.style.setProperty('flex', 'none', 'important');
          });
          if (flkty) {
            if (mobileCellAlign) {
              // data-cell-align-desktop preserva o alinhamento que a seção já
              // tinha no desktop; sem ele, vale o comportamento de sempre.
              flkty.options.cellAlign = (window.innerWidth <= 767) ? mobileCellAlign : (slideshow.dataset.cellAlignDesktop || baseCellAlign);
            }
            requestAnimationFrame(function () { flkty.resize(); });
          }
        }

        applyPxWidths(null);

        args.on.ready = function () {
          var flickity = this;
          var resizeTimer;
          window.addEventListener('resize', function () {
            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(function () {
              applyPxWidths(flickity);
              if (next_button && slideshow.classList.contains('products')) {
                slideshow.centerArrows(flickity, prev_button, next_button);
              }
            }, 60);
          });
        };
      }
      if (progress_bar) {
        let loop = slideshow.dataset.loop === 'true';
        var progressOffset = parseInt(progress_bar.dataset.initialOffset) || 0;
        if (loop) {
          args.on.change = function (index) {
            var total = this.slides.length;
            var progress = total <= 1 ? 0 : index / (total - 1);
            progress_bar.style.width = (progressOffset + progress * (100 - progressOffset)) + '%';
          };
        } else {
          args.wrapAround = false;
          args.on.scroll = function (progress) {
            progress = Math.max(0, Math.min(1, progress));
            progress_bar.style.width = (progressOffset + progress * (100 - progressOffset)) + '%';
          };
        }
      }
      const flkty = new Flickity(slideshow, args);

      slideshow.dataset.initiated = true;

      // When the viewport crosses the desktop/mobile breakpoint, swap which of the
      // two background videos is playing so the newly revealed one isn't left frozen.
      if (slideshow.querySelector('.slideshow__slide-video-bg--mobile')) {
        this._videoBreakpoint = window.matchMedia('(min-width: 768px)');
        this._onVideoBreakpointChange = () => {
          const slide = flkty.selectedElement;
          if (!slide) return;
          const active = slideshow.activeVideoContainer(slide);
          if (!active) return;
          slideshow.videoPauseAll(slide, active);
          const iframe = active.querySelector('iframe');
          if (iframe && iframe.classList.contains('lazyload')) {
            lazySizes.loader.checkElems();
          }
          slideshow.videoPlay(active);
        };
        this._videoBreakpoint.addEventListener('change', this._onVideoBreakpointChange);
      }


      if (prev_button) {
        prev_button.addEventListener('click', (event) => {
          flkty.previous();
        });
        prev_button.addEventListener('keyup', (event) => {
          flkty.previous();
        });
        next_button.addEventListener('click', (event) => {
          flkty.next();
        });
        next_button.addEventListener('keyup', (event) => {
          flkty.next();
        });
      }
      if (Shopify.designMode) {
        slideshow.addEventListener('shopify:block:select', (event) => {
          let index = slideshow_slides.indexOf(event.target);
          flkty.select(index);
        });
      }

    }
    disconnectedCallback() {
      if (this._videoBreakpoint && this._onVideoBreakpointChange) {
        this._videoBreakpoint.removeEventListener('change', this._onVideoBreakpointChange);
        this._videoBreakpoint = null;
        this._onVideoBreakpointChange = null;
      }
      if (this._splitInstance) {
        try { this._splitInstance.revert(); } catch (e) {}
        this._splitInstance = null;
      }
      if (this._animations) {
        this._animations.forEach(function (tl) { if (tl) { try { tl.kill(); } catch (e) {} } });
        this._animations = null;
      }
    }
    // A slide can hold two background videos (desktop + mobile). Returns the one
    // that belongs to the current viewport, so only it gets played.
    activeVideoContainer(slide) {
      const containers = slide.querySelectorAll('.slideshow__slide-video-bg');
      if (containers.length < 2) {
        return containers[0] || null;
      }
      const wanted = window.matchMedia('(min-width: 768px)').matches ? 'desktop' : 'mobile';
      let match = null;
      containers.forEach((container) => {
        if (container.dataset.viewport === wanted) {
          match = container;
        }
      });
      return match || containers[0];
    }
    videoPauseAll(slide, except) {
      slide.querySelectorAll('.slideshow__slide-video-bg').forEach((container) => {
        if (container !== except) {
          this.videoPause(container);
        }
      });
    }
    videoPause(video_container) {
      setTimeout(() => {
        if (video_container.dataset.provider === 'hosted') {
          video_container.querySelector('video').pause();
        } else if (video_container.dataset.provider === 'youtube') {
          video_container.querySelector('iframe').contentWindow.postMessage(JSON.stringify({
            event: "command",
            func: "pauseVideo",
            args: ""
          }), "*");
        } else if (video_container.dataset.provider === 'vimeo') {
          video_container.querySelector('iframe').contentWindow.postMessage(JSON.stringify({
            method: "pause"
          }), "*");
        }
      }, 10);
    }
    videoPlay(video_container) {
      setTimeout(() => {
        if (video_container.dataset.provider === 'hosted') {
          video_container.querySelector('video').play();
        } else if (video_container.dataset.provider === 'youtube') {
          video_container.querySelector('iframe').contentWindow.postMessage(JSON.stringify({
            event: "command",
            func: "playVideo",
            args: ""
          }), "*");
        } else if (video_container.dataset.provider === 'vimeo') {
          video_container.querySelector('iframe').contentWindow.postMessage(JSON.stringify({
            method: "play"
          }), "*");
        }
      }, 10);
    }
    prepareAnimations(slideshow, animations) {
      if (!slideshow.dataset.animationsReady) {
        const allSlides = slideshow.querySelectorAll('.slideshow__slide');

        // Collect .split-text elements only from non-video slides — video slides
        // use a simple fade animation that doesn't need SplitText.
        const splitTextTargets = [];
        allSlides.forEach(function (slide) {
          if (!slide.querySelector('.slideshow__slide-video-bg')) {
            slide.querySelectorAll('.split-text').forEach(function (el) { splitTextTargets.push(el); });
          }
        });
        if (splitTextTargets.length) {
          this._splitInstance = new SplitText(splitTextTargets, {
            type: 'lines, words',
            linesClass: 'line-child'
          });
        }

        allSlides.forEach((item, i) => {
          const isVideoSlide = !!item.querySelector('.slideshow__slide-video-bg');
          let tl = gsap.timeline({ paused: true });
          animations[i] = tl;

          if (slideshow.dataset.transition == 'swipe') {
            tl.fromTo(item, {
              clipPath: 'polygon(0 0, 0 0, 0 100%, 0 100%)'
            }, {
              duration: 0.7,
              clipPath: "polygon(0 0, 100% 0, 100% 100%, 0 100%)"
            }, "start");
          }
          tl.to(item.querySelector('.slideshow__slide-bg'), {
            duration: 1.5,
            scale: 1
          }, "start");

          if (isVideoSlide) {
            // SIMPLE animation for video slides: fade-in + small slide-up of whole text elements.
            // No SplitText, no fragmented spans → no "pontinhos" flash possible.
            const textEls = [];
            const sub = item.querySelector('.subheading');
            const heading = item.querySelector('.slideshow__slide-content--heading');
            const desc = item.querySelector('p:not(.subheading)');
            const btns = item.querySelectorAll('.button');
            if (sub) textEls.push(sub);
            if (heading) textEls.push(heading);
            if (desc) textEls.push(desc);
            btns.forEach(function (b) { textEls.push(b); });

            if (textEls.length) {
              // Apply initial y offset synchronously. Opacity stays at CSS opacity:0
              // so nothing is visible until the timeline animates autoAlpha to 1.
              gsap.set(textEls, { y: 20 });
              tl.to(textEls, {
                duration: 0.7,
                autoAlpha: 1,
                y: 0,
                stagger: 0.12,
                ease: 'power2.out'
              }, 0.2);
            }
          } else {
            // COMPLEX animation for non-video slides: SplitText line-child reveal.
            const headingDivs = item.querySelectorAll('.slideshow__slide-content--heading .line-child div');
            const descDivs = item.querySelectorAll('p:not(.subheading) .line-child div');
            const buttons = item.querySelectorAll('.button');
            const subheading = item.querySelector('.subheading');

            // Force initial hidden state synchronously.
            if (headingDivs.length) gsap.set(headingDivs, { yPercent: 100 });
            if (descDivs.length) gsap.set(descDivs, { yPercent: 100 });
            if (buttons.length) gsap.set(buttons, { y: '100%' });
            if (subheading) gsap.set(subheading, { autoAlpha: 0 });

            let button_offset = 0;

            if (subheading) {
              tl.to(subheading, { duration: 0.5, autoAlpha: 1 }, 0);
              button_offset += 0.5;
            }
            if (item.querySelector('.slideshow__slide-content--heading')) {
              let h1_duration = 0.5 + ((headingDivs.length - 1) * 0.05);
              tl.fromTo(headingDivs, { yPercent: 100 }, {
                duration: h1_duration,
                yPercent: 0,
                stagger: 0.05
              }, 0);
              button_offset += h1_duration;
            }
            if (item.querySelector('p:not(.subheading)')) {
              let p_duration = 0.5 + ((descDivs.length - 1) * 0.02);
              tl.fromTo(descDivs, { yPercent: 100 }, {
                duration: p_duration,
                yPercent: 0,
                stagger: 0.02
              }, 0);
              button_offset += p_duration;
            }
            if (buttons.length) {
              tl.fromTo(buttons, { y: '100%' }, {
                duration: 0.5,
                y: '0%',
                stagger: 0.1,
              }, button_offset * 0.2);
            }
          }

          item.dataset.timeline = tl;
          tl.pause(0);
        });
        slideshow.dataset.animationsReady = true;
      }
    }
    animateSlides(i, animations) {
      const run = function () {
        animations[i].timeScale(1).restart();
      };
      Promise.race([
        document.fonts.ready,
        new Promise(function (resolve) { setTimeout(resolve, 250); })
      ]).then(run);
    }
    animateReverse(i, animations) {
      animations[i].timeScale(3).reverse();
    }
    centerArrows(flickity, prev_button, next_button) {
      let first_cell = flickity.cells[0],
        max_height = 0,

        image_height = first_cell.element.querySelector('.product-card--featured-image')?.clientHeight || 0;

      flickity.cells.forEach((item, i) => {
        if (item.size.height > max_height) {
          max_height = item.size.height;
        }
      });


      if (max_height > image_height) {
        let difference = (max_height - image_height) / -2;

        prev_button.style.transform = 'translateY(' + difference + 'px)';
        next_button.style.transform = 'translateY(' + difference + 'px)';
      }
    }
  }
  customElements.define('slide-show', SlideShow);
}